
import axios from 'axios';
import { AllEmployeesResponseModel, EmployeeResponseModel} from '@gtpl/shared-models/gtpl';
import {EmployeeDesignationRequest, EmployeeRequest,EmployeeRoleRequest } from '@gtpl/shared-models/masters'
import connection from './connection';
import { CommonResponse } from '@gtpl/shared-models/production-management';

export class EmployeeService { 
 
URL = connection.DEPLOY_URL + '/employee-details';

  
async  getActiveEmployeesById(employeeRequest:EmployeeRequest): Promise<EmployeeResponseModel> {
      return await axios.post(this.URL + '/getActiveEmployeesById', employeeRequest)
              .then(res => {
                  return res.data
              })
 }
 async getAllActiveEmployees(): Promise<AllEmployeesResponseModel> {
    return await axios.post(this.URL + '/getAllActiveEmployees').then((res) => {
      return res.data;
    });
  }

  async getActiveEmployeesByRole(employeeRoleReq: EmployeeRoleRequest): Promise<AllEmployeesResponseModel> {
    return await axios.post(this.URL + '/getActiveEmployeesByRole',employeeRoleReq).then((res) => {
      return res.data;
    });
  }

  async getAllActiveEmployeesForLeaves(): Promise<AllEmployeesResponseModel> {
    return await axios.post(this.URL + '/getAllActiveEmployeesForLeaves').then((res) => {
      return res.data;
    });
  } 

  async updateDesignationForDesignationAction(request:EmployeeDesignationRequest): Promise<CommonResponse> {
    return await axios.post(this.URL + '/updateDesignationForDesignationAction',request).then((res) => {
      return res.data;
    });
  } 

} 